import { Router } from "@reach/router"
import { Error404 } from "source/shared/Error404"
import { Household } from "./Household"
import { HouseholdsIndex } from "./HouseholdsIndex"
import { HouseholdMemberEdit } from "./HouseholdMemberEdit"

export function Households() {
  return (
    <Router>
      <HouseholdsIndex path="/" />
      <Household path="/:householdId" />
      <HouseholdMemberEdit path="/:householdId/household-members/:householdMemberId/contact-and-info/edit" />
      <Error404 path="*" />
    </Router>
  )
}
